/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedMyAccountDetailsLinesStyles } from "@monsma/App/ComponentExtensions/OrderLinesListExtension";
import { rfqQuoteDetailsSalesRepProductListStyles } from "@monsma/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { css } from "styled-components";

rfqQuoteDetailsSalesRepProductListStyles.countGridItem = {
    width: 6,
    style: { marginTop: "8px", fontWeight: 600 },
};

rfqQuoteDetailsSalesRepProductListStyles.xRfqQuoteDetailsSalesRepProductListStyles = {
    quotedPricingWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            flex-direction: column;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quantityHeadingAndText =
    sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent;

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingText = {
    weight: "bold",
    css: css`
        font-size: 10px;
        text-transform: uppercase;
        margin-bottom: 5px;
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.quoteLineButton = {
    css: css`
        margin-top: 10px;
        display: none;
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.quoteAllButton = {
    css: css`
        display: none;
    `,
};
